import { ConstructionWorkMap } from "modules/construction-work/src/Entity/Work/ConstructionWorkMap";
import { Category } from "modules/construction-work/src/Entity/IniData/Category";

export default class WorkMapper {
    private categoryMap: Map<string, Category>;

    constructor(categories: Category[]) {
        this.categoryMap = new Map(
            categories.map(category => [String(category.id), category])
        );
    }

    build(item: {geoObject: string}): ConstructionWorkMap {
        const parseGeoObject = JSON.parse(item.geoObject);
        const categoryId = parseGeoObject.properties.categoryId as string;
        const settingsMarker = this.categoryMap.get(categoryId);
        return ConstructionWorkMap.createByObj({
            ...parseGeoObject,
            properties: { ...parseGeoObject.properties, settingsMarker }
        });
    }
}
